import Entity from "./Entity";

export default class MapObjectStatusTemplate extends Entity {
    constructor(data) {
        super(data);

        this.attributeKeys = [
            "id", "active", "title", "color", "excludeFromWebViewerList"
        ];
    }
}
